/**
 * Auto-select colour swatches on colour collection pages.
 * Targets .yeti-dot buttons with title attribute matching the collection colour.
 * Works with infinite scroll via MutationObserver.
 */
(function() {
  var heading = document.querySelector(".collection-banner__heading, .collection__title, h1");
  if (!heading) return;
  var titleLower = heading.textContent.toLowerCase().trim();

  var colours = [
    "rescue red","big sky","firefly","venom","navy","charcoal","black","white",
    "seafoam","coral","agave teal","alpine yellow","cosmic lilac","king crab",
    "camp green","highland olive","bimini pink","sandstone pink","power pink",
    "nordic blue","nordic purple","canopy green","reef blue","tropical pink",
    "wild vine red","key lime","cape taupe","papaya","daybreak yellow",
    "beekeeper","cherry blossom","solar flare","moon dust","wetlands camo",
    "royal blue","brick red","stainless steel","chartreuse","ridgeline",
    "lowcountry peach","harbor pink","peak purple","ultramarine violet",
    "black forest green","big wave blue"
  ];

  var matched = null;
  for (var i = 0; i < colours.length; i++) {
    if (titleLower.indexOf(colours[i]) !== -1) {
      if (!matched || colours[i].length > matched.length) matched = colours[i];
    }
  }
  if (!matched) return;

  function clickMatching(root) {
    var dots = root.querySelectorAll("button.yeti-dot");
    var clicked = false;
    dots.forEach(function(dot) {
      var dotTitle = (dot.getAttribute("title") || "").toLowerCase();
      if (dotTitle.indexOf(matched) !== -1) {
        dot.click();
        clicked = true;
      }
    });

    if (!clicked) {
      // The matching dot may be off-screen in the swatch slider.
      // Click "Next" arrows to scroll through all swatches and retry.
      var sliders = root.querySelectorAll(".yeti-swatch-slider, [class*='swatch-slider']");
      if (sliders.length === 0 && root !== document) {
        sliders = root.closest ? [root.closest(".yeti-swatch-slider, [class*='swatch-slider']")] : [];
      }
      // For each product card that has a slider, advance and check
      var cards = root.querySelectorAll("[class*='product-card'], .fcg__card");
      if (cards.length === 0 && root.classList) cards = [root];
      cards.forEach(function(card) {
        var cardDots = card.querySelectorAll("button.yeti-dot");
        var hasMatch = false;
        cardDots.forEach(function(d) {
          if ((d.getAttribute("title") || "").toLowerCase().indexOf(matched) !== -1) hasMatch = true;
        });
        if (hasMatch) return; // already visible, was clicked above

        var nextArrow = card.querySelector(".yeti-swatch-slider__arrow[aria-label*='Next'], .yeti-swatch-slider__arrow:last-of-type");
        if (!nextArrow) return;

        var attempts = 0;
        var maxAttempts = 20;
        function tryAdvance() {
          if (attempts >= maxAttempts) return;
          attempts++;
          nextArrow.click();
          setTimeout(function() {
            var allDots = card.querySelectorAll("button.yeti-dot");
            var found = false;
            allDots.forEach(function(d) {
              var t = (d.getAttribute("title") || "").toLowerCase();
              if (t.indexOf(matched) !== -1) {
                d.click();
                found = true;
              }
            });
            if (!found) tryAdvance();
          }, 150);
        }
        tryAdvance();
      });
    }
  }

  // Initial (slightly longer delay to let swatch sliders render)
  setTimeout(function() { clickMatching(document); }, 800);

  // Infinite scroll
  var obs = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          setTimeout(function() { clickMatching(node); }, 300);
        }
      });
    });
  });
  obs.observe(document.body, { childList: true, subtree: true });
})();
